import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const differentialCentrifugalSedimentation = {
    jpath: ['spectra', 'differentialCentrifugalSedimentation'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default differentialCentrifugalSedimentation;
//# sourceMappingURL=differentialCentrifugalSedimentation.js.map